import * as React from "react"
import { Typography } from "@mui/material"


export default function infoColumn() {
	return [{
		name: 'reportName', label: 'Report Name',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { maxWidth: 200} }),
			customBodyRowRenderLite: (value, row) => {
				return <Typography>{value}</Typography>
			}
		}
	}]
}